import { SectionHeading } from "./shared";

export default function ProcessSection({ t }) {
  const items = t.timeline || t.processSteps || [];
  return (
    <section className="bg-[#FAF5EE] py-16 sm:py-24 lg:py-32" data-testid="weddings-process">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-10">
        <SectionHeading
          eyebrow={t.timelineEyebrow || t.processEyebrow}
          title={t.timelineTitle || t.processTitle}
          titleAccent={t.timelineTitleAccent || t.processTitleAccent}
          subtitle={t.timelineSubtitle || t.processSubtitle}
        />
        <div className="relative">
          <div className="absolute left-4 sm:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-[#C9A87C] via-[#C9A87C]/40 to-transparent sm:-translate-x-px" aria-hidden="true" />
          <ol className="space-y-8 sm:space-y-12">
            {items.map((s, i) => {
              const right = i % 2 === 1;
              const when = s.when || s.num;
              return (
                <li key={i} className={`relative pl-12 sm:pl-0 sm:grid sm:grid-cols-2 sm:gap-12 sm:items-start`}
                    data-testid={`weddings-timeline-${i}`}>
                  <span className="absolute left-4 sm:left-1/2 top-1.5 w-3 h-3 sm:w-3.5 sm:h-3.5 rounded-full bg-[#C9A87C] ring-4 ring-[#FAF5EE] -translate-x-1/2" aria-hidden="true" />
                  <div className={`${right ? "sm:col-start-2 sm:pl-8" : "sm:pr-8 sm:text-right"}`}>
                    <p className="text-[10px] sm:text-[11px] tracking-[0.3em] text-[#8B6F47] mb-1.5 sm:mb-2 font-medium">{when}</p>
                    <h3 className="text-xl sm:text-2xl text-[#1F1815] mb-2 sm:mb-3"
                        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
                      {s.title}
                    </h3>
                    <p className="text-sm sm:text-[15px] text-[#6B5D4F] font-light leading-relaxed">{s.text}</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
